import Vue from 'vue'
import helper from '../mixins/helper'

/**
 * Filtro VueJS para exibir datas no format pt-br
 */
Vue.filter('dateEnToBr', function (value) {
  if (!value) return ''
  return helper.methods.dateFormat(value, 'br')
})

/**
 * Filtro VueJS para exibir data/hora no format pt-br
 */
Vue.filter('dateTimeEnToBr', function (value) {
  if (!value) return ''
  return helper.methods.dateTimeFormat(value, 'br', true)
})

/**
 * Filtro VueJS para exibir valor monetário no format pt-br
 */
Vue.filter('currencyEnToBr', function (value) {
  if (value === 0) return '0,00'
  if (!value) return ''
  return helper.methods.currencyEnToBr(value)
})



// WEBPACK FOOTER //
// ./src/app/filters.js